<ion-content class="update-content">
  <div class="barra-color-topo"></div>

  <ion-img
    class="logo"
    src="../../../../assets/image/timemultipremiado.png"
  ></ion-img>

  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-col size-xs="12" size-sm="10" size-md="8" size-lg="5" size-xl="4">
        <div class="update-card">
          @if (urlImage) {
          <div class="update-image-wrapper">
            <ion-img class="update-image" [src]="urlImage"></ion-img>
          </div>
          } @else {
          <div class="update-icon-wrapper">
            <ion-icon name="rocket-outline" class="update-icon"></ion-icon>
          </div>
          }

          <p class="update-title">{{ title }}</p>
          <p class="update-subtitle">{{ subtitle }}</p>

          @if (changeLog && changeLog.length > 0) {
          <div class="change-log-wrapper">
            <p class="change-log-title">O que mudou:</p>
            <ul class="change-log-list">
              @for (item of changeLog; track item) {
              <li>{{ item }}</li>
              }
            </ul>
          </div>
          }

          <ion-button
            expand="block"
            color="success"
            class="btn-update"
            (click)="touchUpdate()"
          >
            ATUALIZAR AGORA
          </ion-button>

          @if (!forceUpdate) {
          <ion-button
            expand="block"
            fill="clear"
            color="dark"
            class="btn-later"
            (click)="touchClose()"
          >
            Já atualizei
          </ion-button>
          }
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
